import { V2RohsLegislationBriefing } from '../../components/V2RohsLegislationBriefing'
import { V2ProductRegulationPageShell } from './V2ProductRegulationPageShell'

type V2ProductRohsRegulationPageProps = {
  productId: string
}

export function V2ProductRohsRegulationPage({
  productId,
}: V2ProductRohsRegulationPageProps) {
  return (
    <V2ProductRegulationPageShell productId={productId} law='rohs'>
      {(rohsApplies) => (
        <V2RohsLegislationBriefing
          productId={productId}
          rohsApplies={rohsApplies}
        />
      )}
    </V2ProductRegulationPageShell>
  )
}
